<po-page-default>

    <iframe width="100%" height="100%" src="https://preview.totvsnews.engpro.totvs.com.br/"></iframe>
    <div style="height: 40px;"></div>
</po-page-default>